'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseAttributes', ['$scope', '$q', 'LicenseCategories', 'LicenseCategoryCertificationFields', 'Format', 'Licenses', 'LicenseCategoryCertificationAttributes', '$stateParams',
    function ($scope, $q, LicenseCategories, LicenseCategoryCertificationFields, Format, Licenses, LicenseCategoryCertificationAttributes, $stateParams) {
        $scope.resetLicense();
        $scope.saving = false;
        $scope.initial = true;
        $scope.loading = true;
        $scope.types = [
            { id: 'text', name: 'Text' },
            { id: 'date', name: 'Date' },
            { id: 'select', name: 'Select' },
            { id: 'multi select', name: 'Multi Select' }
        ]

        var a = LicenseCategoryCertificationAttributes.get($stateParams.licenseCategoryID).then(function (licenseCategoryCertificationAttributes) {
            $scope.license_category_certification_attributes = licenseCategoryCertificationAttributes;
        });

        var b = LicenseCategoryCertificationFields.get($stateParams.licenseCategoryID).then(function (licenseCategoryCertificationFields) {
            $scope.license_category_certification_fields = licenseCategoryCertificationFields;
            if ($scope.license_category_certification_fields) {
                //Disable sort order for initial issue date and created on since those aren't editable and will always be at the bottom
                $scope.license_category_certification_fields.forEach(function (license_category_certification_field, i) {
                    if (license_category_certification_field.certification_field_id == 'cc9a5c29-bbf4-4988-85a2-6730001172c0' || license_category_certification_field.certification_field_id == '90913ceb-373c-489c-8364-2aaa8ea2e977') {
                        $scope.license_category_certification_fields[i].sort_order = undefined;
                    }
                });
            }
        });

        var c = LicenseCategories.getByID($stateParams.licenseCategoryID).then(function(licenseCategory){
            $scope.license_category = licenseCategory;
        });

        $q.all([a, b, c]).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.format = function (value) {
            return Format.label(value);
        }

        $scope.add = function (array) {
            array.push({ license_category_id: $stateParams.licenseCategoryID });
        }

        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.save = function () {
            $scope.saving = true;
            // Save license before attributes. Potentially race if an attribute was added.
            var licenseProm = Licenses.save($scope.license);

            $q.all([licenseProm]).then(function (data) {
                var license = data[0];
                $scope.setMasterLicense(license);
                var all = [];

                $scope.license_category_certification_attributes.forEach(function (license_category_certification_attribute, i) {
                    all.push(LicenseCategoryCertificationAttributes.save(license_category_certification_attribute, $scope.license.id).then(function (lcca) {
                        if (license_category_certification_attribute.id == null) {
                            $scope.license.license_category_certification_attributes.push(lcca);
                            $scope.masterLicense.license_category_certification_attributes.push(lcca);
                            $scope.license_category_certification_attributes[i].id = lcca.id;
                        }
                    }));
                })

                $scope.license_category_certification_fields.forEach(function (license_category_certification_field, i) {
                    all.push(LicenseCategoryCertificationFields.save(license_category_certification_field));
                })

                $q.all(all).then(function () {
                    $scope.saving = false;
                }).catch(function (response) {
                    // handle error
                });
            }).catch(function (response) {
                // handle error
            });          
        }
    }])
;